import {Component, Input, OnInit} from '@angular/core';
import {HgGdvPartnerBaseComponent} from "../hg-gdv-partner-base.component";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";
import {HgPartnerDto} from "../../../../../model/dto/entity/hg-partner.dto";

@Component({
    selector: 'hg-gdv-partner-side',
    templateUrl: 'hg-gdv-partner-side.component.html',
    standalone: false
})
export class HgGdvPartnerSideComponent extends HgGdvPartnerBaseComponent implements OnInit {
    @Input() dto: HgPartnerDto;
    navigationItems: NavigationItem[] = [
        {
            label: 'gdvPartner',
            action: 'gdvPartner',
            icon: 'fa-solid fa-info-circle',
            tooltip: 'GDV Partner',
            toggleable: false,
            default: true
        },
        {
            label: 'test',
            action: 'test',
            icon: 'fa-solid fa-vials',
            tooltip: 'Test',
            toggleable: false,
            default: false
        },
        {
            label: 'GDV-Importe',
            action: 'imports',
            icon: 'fa-solid fa-file-import',
            tooltip: 'GDV-Importe',
            toggleable: false,
            default: false
        },
    ];

    ngOnInit(): void {
        super.ngOnInit();
    }

}
